import * as React from "react";
import { withFormsy, IFormsyDecorator } from "formsy-react";

export interface Item {
  label: string;
  value: string;
}

export interface ButtonProps {
  button: Item;
  onClick(button: Item): void;
  active: boolean;
  name: string;
}

export class RadioButton extends React.PureComponent<ButtonProps> {
  render() {
    return (
      <button
        className={
          "btn btn-radio" + (this.props.active ? " btn-radio-active" : "")
        }
        onClick={this.onClick}
        type="button">
        <span>{this.props.button.label}</span>
      </button>
    );
  }

  onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    this.props.onClick(this.props.button);
  };
}

interface Props extends IFormsyDecorator {
  name: string;
  buttons: Item[];
  onChange?(button: Item): void;
}

class ButtonGroup extends React.PureComponent<Props> {
  render() {
    return (
      <div className="" role="group">
        {this.props.buttons.map((button) => {
          return (
            <RadioButton
              onClick={this.onClick}
              active={button.value == this.props.getValue()}
              button={button}
              name={this.props.name}
              key={button.value}
            />
          );
        })}
      </div>
    );
  }

  onClick = (button: Item) => {
    this.props.setValue(button.value);
    this.props.onChange && this.props.onChange(button);
  };
}

export default withFormsy(ButtonGroup);
